// TreatmentCard.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import "./treatmentCard.scss";
import Text from "../../atoms/Text/Text";
import { useTranslation } from "react-i18next";
import Modal from "../../Modal/Modal";
import Icon from "../../atoms/Icon/Icon";
import Image from "../../atoms/Image/Image";
import womendeluxewebp from "../../../assets/images/Cards/womendeluxe800.webp";
import womendeluxejpg from "../../../assets/images/Cards/womendeluxe800.jpg";
import womenultradeluxewebp from "../../../assets/images/Cards/womenultradeluxe800.webp";
import womenultradeluxejpg from "../../../assets/images/Cards/womenultradeluxe800.jpg";
import mendeluxewebp from "../../../assets/images/Cards/mendeluxe800.webp";
import mendeluxejpg from "../../../assets/images/Cards/mendeluxe800.jpg";
import menultradeluxewebp from "../../../assets/images/Cards/menultradeluxe800.webp";
import menultradeluxejpg from "../../../assets/images/Cards/menultradeluxe800.jpg";
import kidsdeluxewebp from "../../../assets/images/Cards/kidsdeluxe800.webp";
import kidsdeluxejpg from "../../../assets/images/Cards/kidsdeluxe800.jpg";
import hairplaywebp from "../../../assets/images/Cards/hairplay800.webp";
import hairplayjpg from "../../../assets/images/Cards/hairplay800.jpg";
import hairplaydeluxewebp from "../../../assets/images/Cards/hairplaydeluxe800.webp";
import hairplaydeluxejpg from "../../../assets/images/Cards/hairplaydeluxe800.jpg";
import backmassagewebp from "../../../assets/images/Cards/backmassage800.webp";
import backmassagejpg from "../../../assets/images/Cards/backmassage800.jpg";
import backmassagedeluxewebp from "../../../assets/images/Cards/backmassagedeluxe800.webp";
import backmassagedeluxejpg from "../../../assets/images/Cards/backmassagedeluxe800.jpg";
import footmassagewebp from "../../../assets/images/Cards/footmassage800.webp";
import footmassagejpg from "../../../assets/images/Cards/footmassage800.jpg";
import footmassagedeluxewebp from "../../../assets/images/Cards/footmassagedeluxe800.webp";
import footmassagedeluxejpg from "../../../assets/images/Cards/footmassagedeluxe800.jpg";
import bodymassagewebp from "../../../assets/images/Cards/bodymassage800.webp";
import bodymassagejpg from "../../../assets/images/Cards/bodymassage800.jpg";
import hairmesotherapywebp from "../../../assets/images/Cards/hairmesotherapy800.webp";
import hairmesotherapyjpg from "../../../assets/images/Cards/hairmesotherapy800.jpg";
import mesocombidealwebp from "../../../assets/images/Cards/mesocombideal800.webp";
import mesocombidealjpg from "../../../assets/images/Cards/mesocombideal800.jpg";
import deluxebackmassagewebp from "../../../assets/images/Cards/deluxebackmassage1600.webp";
import deluxebackmassageljpg from "../../../assets/images/Cards/deluxebackmassage1600.jpg";
import ultradeluxebackmassagewebp from "../../../assets/images/Cards/ultradeluxebackmassage1600.webp";
import ultradeluxebackmassageljpg from "../../../assets/images/Cards/ultradeluxebackmassage1600.jpg";
import deluxebackfootmassagewebp from "../../../assets/images/Cards/deluxebackfootmassage1600.webp";
import deluxebackfootmassageljpg from "../../../assets/images/Cards/deluxebackfootmassage1600.jpg";
import hairplayfootmassagewebp from "../../../assets/images/Cards/hairplayfootmassage1600.webp";
import hairplayfootmassageljpg from "../../../assets/images/Cards/hairplayfootmassage1600.jpg";
import BookingButton from "../../molecules/BookingButton/BookingButton";

const TreatmentCard = ({
  title,
  i18nTitle,
  duration,
  price,
  description,
  subdescription,
  rules,
  rules2,
  steps,
  link,
  showDurationIcon,
  index,
  isFocused,
  onMouseEnter,
}) => {
  const { t } = useTranslation();
  const [isExpanded, setExpanded] = useState(false);

  const stepsKeys = steps ? Object.keys(steps) : [];
  const imageKey = title;
  // Gebruik i18nTitle indien aanwezig, anders title
  const displayTitle = i18nTitle || title;
  const images = {
    "Women Deluxe": {
      webp: womendeluxewebp,
      fallback: womendeluxejpg,
    },
    "Women Ultra Deluxe": {
      webp: womenultradeluxewebp,
      fallback: womenultradeluxejpg,
    },
    "Men Deluxe": {
      webp: mendeluxewebp,
      fallback: mendeluxejpg,
    },
    "Men Ultra Deluxe": {
      webp: menultradeluxewebp,
      fallback: menultradeluxejpg,
    },
    "Kids Deluxe": {
      webp: kidsdeluxewebp,
      fallback: kidsdeluxejpg,
    },
    "Hair Play": {
      webp: hairplaywebp,
      fallback: hairplayjpg,
    },
    "Hair Play Deluxe": {
      webp: hairplaydeluxewebp,
      fallback: hairplaydeluxejpg,
    },
    "Back Massage": {
      webp: backmassagewebp,
      fallback: backmassagejpg,
    },
    "Back Massage Deluxe": {
      webp: backmassagedeluxewebp,
      fallback: backmassagedeluxejpg,
    },
    "Foot Massage": {
      webp: footmassagewebp,
      fallback: footmassagejpg,
    },
    "Foot Massage Deluxe": {
      webp: footmassagedeluxewebp,
      fallback: footmassagedeluxejpg,
    },
    "Women Body Massage": {
      webp: bodymassagewebp,
      fallback: bodymassagejpg,
    },
    "Hair Mesotherapy": {
      webp: hairmesotherapywebp,
      fallback: hairmesotherapyjpg,
    },
    "Meso Combideal 6+1": {
      webp: mesocombidealwebp,
      fallback: mesocombidealjpg,
    },
    "Deluxe & Back Massage": {
      webp: deluxebackmassagewebp,
      fallback: deluxebackmassageljpg,
    },
    "Ultra Deluxe & Back Massage": {
      webp: ultradeluxebackmassagewebp,
      fallback: ultradeluxebackmassageljpg,
    },
    "Deluxe & Back and Foot Massage": {
      webp: deluxebackfootmassagewebp,
      fallback: deluxebackfootmassageljpg,
    },
    "Hair Play & Foot Massage": {
      webp: hairplayfootmassagewebp,
      fallback: hairplayfootmassageljpg,
    },
  };

  const currentImage = images[imageKey] || {};

  // Determine if this is a mesotherapy card (normal or combideal)
  const isMeso =
    displayTitle === "Hair Mesotherapy" ||
    displayTitle === "Meso Combideal 6+1" ||
    displayTitle === "Mesotherapie" ||
    displayTitle === "Mesotherapie Combideal";

  return (
    <>
      <div
        className={`treatment-card ${isFocused ? "focused" : ""}`}
        onClick={() => setExpanded(true)}
        onMouseEnter={() => onMouseEnter(index)}
        data-index={index}
      >
        <picture>
          <source type="image/webp" srcSet={currentImage.webp} />
          <Image
            className="treatment-card__image"
            src={currentImage.fallback}
            alt={`Image for ${title}`}
            loading="lazy"
          />
        </picture>
        <Text variant="h3" className="treatment-card__title">
          {t(displayTitle)}
        </Text>
        <Text variant="p" className="treatment-card__description">
          {t(description)}
        </Text>

        <div className="treatment-card__divider"></div>

        <div className="treatment-card__container">
          <div className="treatment-card__fromdurationprice">
            {isMeso && (
              <Text variant="p" className="treatment-card__fromLabel">
                {t("treatments.treatmentCards.hairMesotherapy.fromLabel")}
              </Text>
            )}
            <div className="treatment-card__duration-price-container">
              <div className="treatment-card__duration-container">
                {showDurationIcon && (
                  <Icon
                    name="duration"
                    label="Duration"
                    className="treatment-card__duration-icon"
                  />
                )}
                {duration && (
                  <Text variant="p" className="treatment-card__duration">
                    {t(duration)}
                  </Text>
                )}
              </div>
              {/* Prijs */}
              {price && (
                <Text variant="p" className="treatment-card__price">
                  {price}
                </Text>
              )}
            </div>
            {/* rules only in modal, not on card */}
          </div>

          <Icon
            name="seeMore"
            label="More information"
            className={"treatment-card__seemore-icon"}
          />
        </div>
      </div>

      {isExpanded && (
        <Modal onClose={() => setExpanded(false)}>
          <picture>
            <source type="image/webp" srcSet={currentImage.webp} />
            <Image
              className="treatment-card__image"
              src={currentImage.fallback}
              alt={`Image for ${title}`}
            />
          </picture>

          <Text variant="h3" className="treatment-card__title">
            {t(displayTitle)}
          </Text>
          <div className="modal-divider"></div>


          {/* Show rules and rules2 above subdescription for all treatments */}
          {rules && (
            <div>
              <Text variant="p" className="treatment-card__rules">
                {t(rules)}
              </Text>
            </div>
          )}
          {rules2 && !isMeso && (
            <div>
              <Text variant="p" className="treatment-card__rules2">
                {t(rules2)}
              </Text>
            </div>
          )}
          {/* For mesotherapy, rules2 is shown only after subdescription */}

          {/* Beschrijving niet meer in de modal */}

          {subdescription && (
            <p
              className="treatment-card__subdescription"
              dangerouslySetInnerHTML={{ __html: t(subdescription) }}
            />
          )}

          {/* Show rules2 under subdescription for mesotherapy */}
          {isMeso && rules2 && (
            <div>
              <Text variant="p" className="treatment-card__rules2">
                {t(rules2)}
              </Text>
            </div>
          )}

          {stepsKeys.map((key, index) => (
            <div key={index}>
              <Text variant="h4" className="__step-header">
                {t(steps[key].header)}
              </Text>
              <Text variant="p" className="__step-detail">
                {t(steps[key].detail)}
              </Text>
            </div>
          ))}

          {/* rest van de modal ongewijzigd */}

          <div className="__divider"></div>

          {/* Show fromLabel above duration/price for mesotherapy */}
          {isMeso && (
            <Text variant="p" className="treatment-card__fromLabel" style={{ textAlign: "center" }}>
              {t("treatments.treatmentCards.hairMesotherapy.fromLabel")}
            </Text>
          )}

          {duration || price ? (
            <>
              <div className="treatment-card__duration-price-container">
                {duration && (
                  <div className="treatment-card__duration-container">
                    {showDurationIcon && (
                      <Icon
                        name="duration"
                        label="Duration"
                        className="treatment-card__duration-icon"
                      />
                    )}
                    <Text variant="p" className="treatment-card__duration">
                      {t(duration)}
                    </Text>
                  </div>
                )}
                {/* Prijs */}
                {price && (
                  <Text variant="p" className="treatment-card__price">
                    {price}
                  </Text>
                )}
              </div>
            </>
          ) : null}

          <BookingButton link={link} />
        </Modal>
      )}
    </>
  );
};

TreatmentCard.propTypes = {
  title: PropTypes.string,
  i18nTitle: PropTypes.string,
  description: PropTypes.string.isRequired,
  subdescription: PropTypes.string,
  rules: PropTypes.string,
  rules2: PropTypes.string,
  duration: PropTypes.string,
  price: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      detail: PropTypes.string,
    })
  ),
  link: PropTypes.string,
  showDurationIcon: PropTypes.bool,
  onSwipeLeft: PropTypes.func,
  onSwipeRight: PropTypes.func,
  index: PropTypes.number,
  isFocused: PropTypes.bool,
  totalTreatments: PropTypes.number.isRequired, // Add this to ensure proper validation
  onMouseEnter: PropTypes.func.isRequired,
};

export default TreatmentCard;
